const EstadosCobranzaEnum = {
  Cobrado: 11,
  Vencido: 12,
  NoCobrado: 13,
}

export default EstadosCobranzaEnum;
